import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { AmsFile } from '@core/objects/ams-file';
import { Version } from '@core/objects/version';
import { VersionFeedback, FeedbackStatusColorValues, ApprovalStatusColorValues,FeedbackStatusCodeEnum } from '@core/models/version-feedback';
import { VersionShareItem, VersionShare } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';


@Component({
    selector: 'core-version-files-list-checkbox',
    templateUrl: './list-checkbox.component.html',
    styleUrls: ['./list-checkbox.component.scss']
})
export class VersionFilesListCheckboxComponent implements OnInit, OnChanges {

    public readonly FEEDBACK_STATUS_COLORS = FeedbackStatusColorValues;

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() version: Version;
    @Input() disabled: boolean; // TODO
    @Input() feedbacks: Array<VersionShareItem>; // TODO
    @Input()  selected: Array<AmsFile>;
    @Output() selectedChange = new EventEmitter<Array<AmsFile>>();

    public opened: boolean = false;
    public firstOpened: boolean = false;
    public filesUrl: string = "";
    public checked: boolean = false;

    protected feedbacksList: Array<VersionShareItem>;

    constructor(private versionSharesSrv: VersionSharesService) { }

    ngOnInit() {
        this.filesUrl = "/versions/"+ this.version.id +"/assets";
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.feedbacks && changes.feedbacks.currentValue != null){
            this.feedbacksList = this.feedbacks;
        }
    }

    onChange(files: Array<AmsFile>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    openFiles() {
        this.firstOpened = true;
        this.opened = !this.opened;
    }

    // @deprecated oct-2026: legacy share feedback bubbles (VersionFeedback), replaced by VersionShareItem
    // public getBubbleColor(feedback: VersionFeedback){
    //     let color;
    //     // fix for wrong status  or approval in feedbacks to set it yellow. <diego@twonas.com>
    //     if(feedback.approval == null && feedback.status == null){
    //         return this.FEEDBACK_STATUS_COLORS[FeedbackStatusCodeEnum.WRONG_CODE];
    //     }
    //     if (feedback.approval != null){
    //         color = ApprovalStatusColorValues[feedback.approval.status_code];
    //     } else {
    //         color = FeedbackStatusColorValues[feedback.status.status_code];
    //     }
    //     return color;
    // }
    public getBubbleTitle(share: VersionShareItem | VersionShare){
        return this.versionSharesSrv.getVersionShareBubbleTitle(share);
    }

    public getBubbleColor(feedback: VersionShareItem){
        return this.versionSharesSrv.getVersionShareBubbleColor(feedback);
    }

}
